import listReducer from './listReducer'
import modeReducer from './modeReducer'
import {combineReducers} from 'redux'


//Define the STORE/STATE/DB structure here.
const allReducer = combineReducers({
	itemList : listReducer,
	currentMode: modeReducer
})


export default allReducer